import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

import { CountryEnum } from '@cure-common/enum';

@Directive({
  selector: '[appPhoneMask]',
  standalone: true,
})
export class PhoneMaskDirective {
  @Input() country: CountryEnum | null = null;

  constructor(
    private ngControl: NgControl,
    private el: ElementRef<HTMLInputElement>,
  ) {}

  @HostListener('input', ['$event.target.value'])
  onInput(value: string): void {
    const digitsOnly = value.replace(/[^0-9]/g, '');
    this.ngControl.control?.setValue(digitsOnly, { emitEvent: false });
    const formatted = this.formatPhoneNumber(digitsOnly);
    this.el.nativeElement.value = formatted;
  }

  @HostListener('blur')
  onBlur(): void {
    const value = this.ngControl.control?.value || '';
    this.el.nativeElement.value = this.formatPhoneNumber(value);
  }

  private formatPhoneNumber(value: string): string {
    if (this.country === CountryEnum.France) {
      return value.replace(/(\d{2})(?=\d)/g, '$1 ');
    }

    return value.replace(/(\d{3})(?=\d)/g, '$1 ');
  }
}
